import React from "react";
import Header from "./Reusables/Header";
import DownloadImg from "../assests/download.svg";
import GrowthSUmmaryTable from "./Tables/GSTable";
import axiosRequest from "../api/axios";
import SnackBarComponent from "./Helpers/SnackBarComponent";
import CircularProgress from "@mui/material/CircularProgress";
import { CSVLink } from "react-csv";
import "../index.css";
import PeriodSelector from "./PeriodSelector";
const GrowthSummary = () => {
  const [filtersData, setfiltersData] = React.useState({});
  const [RbmListData, setRbmListData] = React.useState([]);
  const [brandListData, setbrandListData] = React.useState([]);
  const [selectedRbm, setselectedRbm] = React.useState("");
  const [selectedBrand, setselectedBrand] = React.useState("");
  const [dataLoaded, setdataLoaded] = React.useState(false);
  const [filtersOutputData, setfiltersOutputData] = React.useState({});
  const [filtersDataSum, setfiltersDataSum] = React.useState({});
  const [severity, setSeverity] = React.useState("");
  const [content, setContent] = React.useState("");
  const [opensb, setOpensb] = React.useState(false);
  const [loader, setLoader] = React.useState(false);
  const [rows, setrows] = React.useState([]);
  const [rowsDownload, setrowsDownload] = React.useState([]);
  const [Quarter, setQuarter] = React.useState("");
  const [Month1, setMonth1] = React.useState("");
  const [Month2, setMonth2] = React.useState("");
  const [Month3, setMonth3] = React.useState("");

  const api_headers = {
    'Content-Type': 'application/json',
    'Authorization': 'Bearer '+localStorage.getItem("Token")
  }
  const [loaderFilter, setLoaderFilter] = React.useState(false);
  let RbmListComponent = [];
  RbmListData.forEach((item, index) => {
    RbmListComponent.push(<option key={index}>{item}</option>);
  });
  let sum_data = {
    m1_adj_sum : 0, 
        m1_oct_sum :0, 
       m1_growth_sum :0, 
        m2_adj_sum : 0, 
        m2_nov_sum :0, 
       m2_growth_sum :0, 
       m3_adj_sum : 0, 
      m3_dec_sum :0, 
      m3_growth_sum :0
  }
  const handleChangeRbm = (event) => {
    for (let item of filtersData) {
      setselectedRbm(event.target.value);
      let flag = true;

      if (item["rbmname"] == event.target.value) {
 
        let brandlist = item["brandname"];
        //   if(item["rbmname"]!=='All'){
        //   if (flagT) {
        //     brandlist = ["All", ...brandlist];
        //     flagT = false
        //   }
        // }
        
        if(event.target.value == "All"){
          setbrandListData(brandlist);
        }else{
          setbrandListData(["All",...brandlist]);
        }
        if (flag) {
          setselectedBrand("All");
          flag = false;
        }
      }
    }
 
    //  setproductsListData(filtersData[event.target.value])
  };

  let brandComponent = [];
  brandListData.forEach((item, index) => {
    brandComponent.push(
      <option value={item} key={index}>
        {item}
      </option>
    );
  });

  

  const handleClose = () => {
    setOpensb(false);
  };
  const handleChangeBrand = (event) => {
    const temp = event.target.value;
    setselectedBrand(temp);
   
  };

  const handleSnackBar = (content, severity) => {
    setOpensb(true);
    setSeverity(severity);
    setContent(content);
  };

  const handleApply = async () => {
    setLoader(true);
    await axiosRequest({
      url: "bu_head_app/growthfiltersresult",
      method: "POST",
      headers: api_headers,
      data: {
        rbmname: selectedRbm,
        brandname: selectedBrand,
        teamcode: localStorage.getItem("teamcode"),
        year:localStorage.getItem('year'),
        quarter:localStorage.getItem('quarter'),
      },
    }).then((data) => {
      if (data.status === 200) {
        setLoader(false);
        setrows(data?.data?.data);
        let tot_data = data?.data?.data
        let m1_adj_sum = 0 
        let m1_oct_sum =0 
        let m1_growth_sum =0 
        let m2_adj_sum = 0 
        let m2_nov_sum =0 
        let m2_growth_sum =0 
        let m3_adj_sum = 0 
        let m3_dec_sum =0 
        let m3_growth_sum =0 
        for (let i = 0; i < tot_data?.length; i++) { 
          
         
          m1_adj_sum = m1_adj_sum+ parseFloat(tot_data[i]["m1_adjusted_budget_value"] != null ? tot_data[i]["m1_adjusted_budget_value"] : 0)
          m1_oct_sum = m1_oct_sum + parseFloat(tot_data[i]["lq_m1_v_sales"] != null ? tot_data[i]["lq_m1_v_sales"] : 0)
          m1_growth_sum = m1_growth_sum + parseFloat(tot_data[i]["m1_growthsummary"] != null ? tot_data[i]["m1_growthsummary"] : 0)
          m2_adj_sum = m2_adj_sum+ parseFloat( tot_data[i]["m2_adjusted_budget_value"] != null ? tot_data[i]["m2_adjusted_budget_value"] : 0)
          m2_nov_sum = m2_nov_sum + parseFloat(tot_data[i]["lq_m2_v_sales"] != null ? tot_data[i]["lq_m2_v_sales"] : 0)
          m2_growth_sum = m2_growth_sum + parseFloat(tot_data[i]["m2_growthsummary"] != null ? tot_data[i]["m2_growthsummary"] : 0)
          m3_adj_sum = m3_adj_sum+ parseFloat(tot_data[i]["m3_adjusted_budget_value"] != null ? tot_data[i]["m3_adjusted_budget_value"] : 0)
          m3_dec_sum = m3_dec_sum + parseFloat(tot_data[i]["lq_m3_v_sales"] != null ? tot_data[i]["lq_m3_v_sales"] : 0)
          m3_growth_sum = m3_growth_sum + parseFloat(tot_data[i]["m3_growthsummary"] != null ? tot_data[i]["m3_growthsummary"] : 0)
        }
        console.log(m1_growth_sum,"^^^^^^^^^^^^^^^^^^^^")
        // console.log(sum_data['m1_oct_sum'],"oct sum")
        sum_data['m1_adj_sum'] = parseFloat(m1_adj_sum).toFixed( 2 );
        sum_data['m1_oct_sum'] = parseFloat(m1_oct_sum).toFixed( 2 );
        sum_data['m1_growth_sum'] =  parseFloat(m1_growth_sum).toFixed( 2 );
        sum_data['m2_adj_sum'] =  parseFloat(m2_adj_sum).toFixed( 2 );
        sum_data['m2_nov_sum'] = parseFloat(m2_nov_sum).toFixed( 2 );
        sum_data['m2_growth_sum'] =  parseFloat(m2_growth_sum).toFixed( 2 );
        sum_data['m3_adj_sum'] =  parseFloat(m3_adj_sum).toFixed( 2 );
        sum_data['m3_dec_sum'] =  parseFloat(m3_dec_sum).toFixed( 2 );
        sum_data['m3_growth_sum'] =  parseFloat(m3_growth_sum).toFixed( 2 );
        // console.log(sum_data,"sum data")
        setfiltersDataSum(sum_data)
        handleSnackBar("Data Loaded Successfully", "success");
        // setfiltersOutputData()
       
      } else {
       
        handleSnackBar("Something went wrong! ", "error");
      }
    });
  };


  const handleDownload = (event) => {
    axiosRequest({
      url: "bu_head_app/downloadfiltergrowth",
      method: "GET",
      headers: api_headers,
    }).then(function (response) {
      const url = URL.createObjectURL(
        new Blob([response.data], {
          //   type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        })
      );
      // let temp_file_name = table + ".csv";
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "Growth Summary Data.csv");
      document.body.appendChild(link);
      link.click();
      // handleSnackBar("downloaded successfully","success");
    });
  };
  const getDownloadAdjustedData = async () => {
    setLoaderFilter(true);
    await axiosRequest({
      url: "bu_head_app/adjusteddatabuh/",
      method: "POST",
      headers: api_headers,
      data: {
        teamcode: localStorage.getItem("teamcode"),
        year: localStorage.getItem("year"),
        quarter: localStorage.getItem("quarter"),
      },
    }).then((data) => {
      if (data.status === 200) {
        setrowsDownload(data?.data?.data)
      } else {
       
      
      
      }
    });
  };
  const getfiltersdata = async () => {
    setLoaderFilter(true);
    await axiosRequest({
      url: "bu_head_app/growthfiltersdata",
      method: "POST",
      headers: api_headers,
      data: {
        team: localStorage.getItem("teamcode"),
        year: localStorage.getItem("year"),
        quarter: localStorage.getItem("quarter"),
      },
    }).then((data) => {
      if (data.status === 200) {
        const temp_list = [];

        setfiltersData(data?.data?.data);
      
        for (let rbm of data?.data?.data) {
          temp_list.push(rbm["rbmname"]);
        }
        setRbmListData(temp_list);
        
        setdataLoaded(true);
        setLoaderFilter(false);
      } else {
        // setLoader(false);
        // handleSnackBar("No Data Found", "error");
        setdataLoaded(false);
        setLoaderFilter(false);
      
      }
    });
  };
  React.useEffect(() => {
    getDownloadAdjustedData();
    getfiltersdata();
    setQuarter(localStorage.getItem('quarter'))
    //logic to display month name based on Quarter
    if (localStorage.getItem('quarter') == "Q1") {
      setMonth1("Jan");
      setMonth2("Feb");
      setMonth3("Mar");
    } else if (localStorage.getItem('quarter') == "Q2") {
      setMonth1("Apr");
      setMonth2("May");
      setMonth3("Jun");
    } else if (localStorage.getItem('quarter') == "Q3") {
      setMonth1("Jul");
      setMonth2("Aug");
      setMonth3("Sep");
    } else if (localStorage.getItem('quarter') == "Q4") {
      setMonth1("Oct");
      setMonth2("Nov");
      setMonth3("Dec");
    }
    // gettabledata();
  }, [localStorage.getItem("quarter"),localStorage.getItem("year")]);
  let headers_growth = [

    { label: "Id", key: "id" },

    { label: "Team code", key: "teamcode" },

    { label: "RBM Name", key: "rbmname" },

    { label: "Brand", key: "brand" },

    { label: String(Month1)+" Adjusted budget value", key: "m1_adjusted_budget_value" },

    { label: String(Month2)+" Adjusted budget value", key: "m2_adjusted_budget_value" },

    { label: String(Month3)+" Adjusted budget value", key: "m3_adjusted_budget_value" },

    { label: String(Month1)+"21", key: "lq_m1_v_sales" },

    { label: String(Month2)+"21", key: "lq_m2_v_sales" },

    { label: String(Month3)+"21", key: "lq_m3_v_sales" },

    { label: String(Month1)+" Growth Summary", key: "m1_growthsummary" },

    { label: String(Month2)+" Growth Summary", key: "m2_growthsummary" },

    { label: String(Month3)+" Growth Summary", key: "m3_growthsummary" },

  ];
  return (
    <div className="bg-white home-screen">
      <p style={{ fontWeight: "550" }}>Growth Summary</p>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <PeriodSelector/>
        <div
          style={{ display: "flex", marginRight: "30px", marginBottom: "20px" }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              marginRight: "5px",
            }}
          >
            <label style={{ fontSize: "small", marginBottom: "5px" }}>
              RBM Name
            </label>
            <select
              className="filter-style"
              id="rbm"
              style={{ marginRight: "5px", width: "200px" }}
              onChange={(event) => handleChangeRbm(event)}
            >
              {loaderFilter === true ? (
                <option value="">Loading...</option>
              ) : (
                <option value="">select rbm name</option>
              )}
              {RbmListComponent}
            </select>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              marginRight: "7px",
            }}
          >
            <label style={{ fontSize: "small", marginBottom: "5px" }}>
              Brand Name
            </label>
            <select
              className="filter-style"
              id="rbm"
              style={{ marginRight: "5px", width: "200px" }}
              onChange={handleChangeBrand}
              value={selectedBrand}
            >
              <option value="volvo">select brand</option>
              {brandComponent}
            </select>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "end",
            }}
          >
            <button className="submit-btn" onClick={handleApply}>
              Apply
            </button>
          </div>
        </div>
        <div style={{display:"flex",alignItems:"center"}}>
        <button
            className="download-btn"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor:"lightgrey",marginRight:"10px",width:"200px"
            }}
            
          >
            <img
              src={DownloadImg}
              alt=""
              style={{ marginRight: "6px", height: "12px" }}
            />
           <CSVLink data={rowsDownload}  filename={"BuhAdjusted.csv"} style={{textDecoration:"none",color:"black"}}>Download Adjusted Data</CSVLink>
          </button>
          <button
            className="download-btn"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
            // onClick={handleDownload}
          >
            <img
              src={DownloadImg}
              alt=""
              style={{ marginRight: "6px", height: "12px" }}
            />

            <CSVLink data={rows} headers={headers_growth} filename={"growth_summary.csv"} style={{textDecoration:"none",color:"black"}}>Download</CSVLink>

          </button>
        </div>
      </div>
      {loader == true ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginTop: "150px",
          }}
        >
          <CircularProgress
            color="inherit"
            display={loader === true ? "true" : "false"}
          />
        </div>
      ) : (
        <div>
        <GrowthSUmmaryTable Month1={Month1} Month2={Month2} Month3={Month3} rows={rows} />
        {loader === false ?(<div
          style={{
           
           height:"135px",
           width:"100%",
           marginBottom:"10px"
           
          }}
        >
        <table className='table-buh'>
    <tr className="table-tr-td-buh">
    <th className="table-tr-td-buh"></th>
      <th className="table-tr-td-buh">Adj.bud V ({Month1})</th>
      <th className="table-tr-td-buh">Adj.bud V ({Month2})</th>
      <th className="table-tr-td-buh">Adj.bud V ({Month3})</th>
      <th className="table-tr-td-buh">Sales V ({Month1})</th>
      <th className="table-tr-td-buh">Sales V ({Month2})</th>
      <th className="table-tr-td-buh">Sales V ({Month3})</th>
      <th className="table-tr-td-buh">% Gr ({Month1})</th>
      <th className="table-tr-td-buh">% Gr ({Month2})</th>
      <th className="table-tr-td-buh">% Gr ({Month3})</th>
    </tr>
    <tr className="table-tr-td-buh">
      <td className="table-tr-td-buh">Total</td>
      <td className="table-tr-td-buh">{filtersDataSum['m1_adj_sum']}</td>
      <td className="table-tr-td-buh">{filtersDataSum['m2_adj_sum']}</td>
      <td className="table-tr-td-buh">{filtersDataSum['m3_adj_sum']}</td>
      <td className="table-tr-td-buh">{filtersDataSum['m1_oct_sum']}</td>
      <td className="table-tr-td-buh">{filtersDataSum['m2_nov_sum']}</td>
      <td className="table-tr-td-buh">{filtersDataSum['m3_dec_sum']}</td>
      <td className="table-tr-td-buh">{filtersDataSum['m1_growth_sum']}</td>
      <td className="table-tr-td-buh">{filtersDataSum['m2_growth_sum']}</td>
      <td className="table-tr-td-buh">{filtersDataSum['m3_growth_sum']}</td>
    </tr>
        </table>
        </div>):""}
        </div>
      )}

      <SnackBarComponent
        opensb={opensb}
        handleClose={handleClose}
        severity={severity}
        content={content}
        autoHideDuration={6000}
      />
    </div>
  );
};

export default GrowthSummary;
